import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { combineReducers } from 'redux';

import dashboardEditReducer from '@/features/Dashboard/pages/Edit/model/dashboardEdit.slice';
import { selectionListener } from '@/features/SymbolSelector/store/selectionListener';
import symbolSelectorReducer from '@/features/SymbolSelector/store/symbolSelector.slice';
import authReducer from '@/slices/authSlice';
import marketsListReducer from '@/slices/marketsListSlice';
import tripTokenReducer from '@/slices/tripTokenSlice';

import listApiKeyReducer from './slices/apiKeyListSlice';
import drawerReducer from './slices/drawerSlice';
import exportReducer from './slices/exportSlice';
import modalReducer from './slices/modalSlice';
import userConfigReducer from './slices/userConfigSlice';
import userCreationReducer from './slices/userCreationSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  tripToken: tripTokenReducer,
  symbolSelector: symbolSelectorReducer,
  marketsList: marketsListReducer,
  userConfig: userConfigReducer,
  listApiKey: listApiKeyReducer,
  userCreation: userCreationReducer,
  modal: modalReducer,
  drawer: drawerReducer,
  export: exportReducer,
  dashboardEdit: dashboardEditReducer
});

export const store = configureStore({
  // process.env.NODE_ENV === 'development'
  devTools: import.meta.env.DEV,
  middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(selectionListener.middleware),
  reducer: rootReducer
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
